import { store } from '@/app/store';
import storage from '@/shared/utils/storage';
import React from 'react';
import {
   CALLKIT_CALLSTATUS,
   AUDIO_CALL_PERMISSION_DENIED_CODE,
   AUDIO_CALL_PERMISSION_DENIED_MSG,
   VIDEO_CALL_PERMISSION_DENIED_CODE,
   VIDEO_CALL_PERMISSION_DENIED_MSG,
   CALLKIT_CALLSCREENSTATUS,
} from '../constants';
import { showPopup } from '@/components/PopupContainer/popupService';
import MicrophonePermissionPopup from '../ui/components/PermissionPopup/MicrophonePermissionPopup';
import CameraPermissionPopup from '../ui/components/PermissionPopup/CameraPermissionPopup';
import { i18n } from '@/localization/i18n';
import { showInfoToast } from '@/shared/utils';

export const CALLKIT_STATUS_MAP = {
   [CALLKIT_CALLSTATUS.RINGING]: 'RINGING',
   [CALLKIT_CALLSTATUS.CONNECTING]: 'CONNECTING',
   [CALLKIT_CALLSTATUS.CONNECTED]: 'CONNECTED',
   [CALLKIT_CALLSTATUS.DISCONNECTED]: 'DISCONNECTED',
   [CALLKIT_CALLSTATUS.REJECTED]: 'BUSY',
   [CALLKIT_CALLSTATUS.ENGAGED]: 'ENGAGED',
   [CALLKIT_CALLSTATUS.TIMEOUT]: 'TIME_OUT',
   [CALLKIT_CALLSTATUS.CALLING]: 'CALLING',
   [CALLKIT_CALLSTATUS.TRY_TO_CONNECT]: 'TRYING_TO_CONNECT',
   [CALLKIT_CALLSTATUS.RECONNECTING]: 'RECONNECTING',
};

export const getCallStatusLabel = (status, t) => {
   const key = CALLKIT_STATUS_MAP[status];
   return key ? t(`calls.STATUS.${key}`) : status;
};

export const getCallUserById = userId => {
   const users = store.getState().callkitData.ongoingCallParticipants;
   return users.find(user => user.userId === userId);
};

export const getLocalUserName = () => {
   return storage.getItem('username');
};

export const isOwnUserReconnecting = () => {
   const currentUserId = getLocalUserName();
   const { ongoingCallParticipants } = store.getState().callkitData;
   const localUser = ongoingCallParticipants.find(p => p.userId === currentUserId);
   return localUser?.callStatus === CALLKIT_CALLSTATUS.RECONNECTING;
};

export const getCallMode = () => {
   const { callMode } = store.getState().callkitData;
   return callMode;
};

export const handleCallError = err => {
   if (err?.statusCode === AUDIO_CALL_PERMISSION_DENIED_CODE || err?.message === AUDIO_CALL_PERMISSION_DENIED_MSG) {
      showPopup({
         id: 'micPermissionPopup',
         visible: true,
         hideHeader: true,
         className: 'mic-permission-modal',
         body: React.createElement(MicrophonePermissionPopup),
      });
      return true;
   } else if (
      err?.statusCode === VIDEO_CALL_PERMISSION_DENIED_CODE ||
      err?.message === VIDEO_CALL_PERMISSION_DENIED_MSG
   ) {
      showPopup({
         id: 'cameraPermissionPopup',
         visible: true,
         hideHeader: true,
         className: 'camera-permission-modal',
         body: React.createElement(CameraPermissionPopup),
      });
      return true;
   }
   return false;
};

export const isAlreadyInCall = () => {
   const { callScreenStatus } = store.getState().callkitData;
   const isActive =
      callScreenStatus &&
      callScreenStatus !== CALLKIT_CALLSCREENSTATUS.ENDED &&
      callScreenStatus !== CALLKIT_CALLSCREENSTATUS.IDLE;
   if (isActive) {
      showInfoToast(i18n.t('calls.ALREADY_IN_A_CALL', { defaultValue: 'You are already in call' }));
      return true;
   }
   return false;
};
